import { useEffect } from "react"

import { ExternalDimensioningResult } from "shared/types/__generated__/graphql"

import { useExternalDimensioningResultQuery } from "entities/dim-configuration/graphql/external-dimensioning.queries.generated"

import { useExternalDimensioningDataExchange } from "./useExternalDimensioningDataExchange"

interface UseExternalDimensioningRestoreArgs {
  externalDimensioningResult: ExternalDimensioningResult | null | undefined
}

export function useExternalDimensioningRestore({
  externalDimensioningResult
}: UseExternalDimensioningRestoreArgs) {
  const { data, loading, refetch } = useExternalDimensioningResultQuery({
    variables: { id: externalDimensioningResult?.transactionId as string },
    skip: !externalDimensioningResult?.transactionId
  })

  const { post } = useExternalDimensioningDataExchange()

  useEffect(() => {
    if (!data && !loading && !!externalDimensioningResult) {
      post(externalDimensioningResult).promise.then(result => {
        if (
          result?.transactionId &&
          result?.transactionId === externalDimensioningResult?.transactionId
        ) {
          refetch({ id: result.transactionId })
        }
      })
    }
  }, [data, loading, externalDimensioningResult])

  return {
    data,
    loading
  }
}
